import useNavigator from "@saleor/hooks/useNavigator";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import Cookies from "js-cookie";
import React, {
  // useContext,
  useState
} from "react";

import SignupPage, { SignupFormData } from "../components/SignupPage";
import { OTPGenerateMutation, SellerCreateMutation } from "../mutations";
import { OTPGenerate } from "../types/OTPGenerate";
import { SellerCreate } from "../types/SellerCreate";
// import { userOTPPath } from "../urls";
import Validate from "./../controllers/CustomValidation";
// import { StoreContext } from "./../store/StoreContext";
const SignupView: React.FC = () => {
  // const [, dispatch] = useContext(StoreContext);
  const navigate = useNavigator();
  const [validations, setValidation] = useState({
    err: {},
    err_msg: []
  });
  const handleUserCreate = (data: SellerCreate) => data;
  const handleOTPGenerate = (data: OTPGenerate) => data;
  const [otp] = OTPGenerateMutation({
    onCompleted: handleOTPGenerate
  });

  Cookies.remove("currentUser");
  return (
    <SellerCreateMutation onCompleted={handleUserCreate}>
      {SellerCreate => {
        const handleSubmit = async (data: SignupFormData) => {
          const initValidations = {
            confirm_password: {
              confirm: true,
              confirm_value: data.password,
              required: true,
              usename: "Confirm Password"
            },
            email: { email: true, required: true, usename: "Email Address" },
            firstName: { required: true, usename: "Firstname" },
            lastName: { required: true, usename: "Lastname" },
            password: { required: true, usename: "Password" }
          };
          const {
            validation_errors,
            validation_has_error,
            validation_message
          } = Validate(initValidations, data);
          if (validation_has_error) {
            const timer = setTimeout(() => {
              //   console.log(validation_errors);
              //   console.log(validation_message);
              setValidation({
                err: validation_errors,
                err_msg: validation_message
              });
              return false;
            }, 1500);
            return () => clearTimeout(timer);
          }
          // STATIC ID FROM SELLER MASTER
          // const sellerMasterID = "R3JvdXA6Ng==";
          const seller_result = await SellerCreate({
            variables: {
              input: {
                // addGroups: [sellerMasterID],
                email: data.email,
                firstName: data.firstName,
                lastName: data.lastName,
                // objectId: permissionGroups.id,
                password: data.password,
                smopUsertypeCode: SmopUserTypeCode.SELLER_MASTER
              }
            }
          });
          // console.log('seller_result');
          // console.log(seller_result);
          const { user, errors } = seller_result.data.sellerCreate;
          // console.log(errors);
          if (errors.length) {
            setValidation({
              err: {},
              err_msg: errors
            });
            return false;
          }
          otp({
            variables: {
              input: {
                user: user.id
              }
            }
          });
          Cookies.set("currentUser", JSON.stringify(user));
          Cookies.set("currentUserPass", data.password);
          navigate("/otp/" + user.id);
        };
        return <SignupPage validations={validations} onSubmit={handleSubmit} />;
      }}
    </SellerCreateMutation>
  );
};
SignupView.displayName = "SignupView";
export default SignupView;
